// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from '../../../services/mock'

export const getData = createAsyncThunk('roles/getData', async () => {

  return {
    data: [
      {
        id: 1,
        totalUsers: 4,
        title: 'Administrador',
        users: [
          {
            size: 'sm',
            title: 'Vinnie Mostowy',
            img: require('@src/assets/images/avatars/2.png').default
          },
          {
            size: 'sm',
            title: 'Allen Rieske',
            img: require('@src/assets/images/avatars/12.png').default
          },
          {
            size: 'sm',
            title: 'Julee Rossignol',
            img: require('@src/assets/images/avatars/6.png').default
          },
          {
            size: 'sm',
            title: 'Kaith Dsouza',
            img: require('@src/assets/images/avatars/11.png').default
          }
        ],
        permissions: ["view-dashboard"]
      },
      {
        id: 2,
        totalUsers: 7,
        title: 'Manager',
        users: [
          {
            size: 'sm',
            title: 'Jimmy Ressula',
            img: require('@src/assets/images/avatars/4.png').default
          },
          {
            size: 'sm',
            title: 'John Doe',
            img: require('@src/assets/images/avatars/1.png').default
          },
          {
            size: 'sm',
            title: 'Kristi Lawker',
            img: require('@src/assets/images/avatars/2.png').default
          },
          {
            size: 'sm',
            title: 'Kaith D',
            img: require('@src/assets/images/avatars/5.png').default
          },
          {
            size: 'sm',
            title: 'Danny Paul',
            img: require('@src/assets/images/avatars/7.png').default
          }
        ]
      },
      {
        id: 3,
        totalUsers: 5,
        title: 'Users',
        users: [
          {
            size: 'sm',
            title: 'Andrew Tye',
            img: require('@src/assets/images/avatars/6.png').default
          },
          {
            size: 'sm',
            title: 'Rishi Swaat',
            img: require('@src/assets/images/avatars/9.png').default
          },
          {
            size: 'sm',
            title: 'Rossie Kim',
            img: require('@src/assets/images/avatars/2.png').default
          },
          {
            size: 'sm',
            title: 'Kim Merchent',
            img: require('@src/assets/images/avatars/10.png').default
          },
          {
            size: 'sm',
            title: 'Sam Dsouza',
            img: require('@src/assets/images/avatars/8.png').default
          }
        ]
      },
      {
        id: 4,
        totalUsers: 3,
        title: 'Support',
        users: [
          {
            size: 'sm',
            title: 'Kim Karlos',
            img: require('@src/assets/images/avatars/3.png').default
          },
          {
            size: 'sm',
            title: 'Katy Turner',
            img: require('@src/assets/images/avatars/9.png').default
          },
          {
            size: 'sm',
            title: 'Peter Adward',
            img: require('@src/assets/images/avatars/12.png').default
          },
          {
            size: 'sm',
            title: 'Kaith Dsouza',
            img: require('@src/assets/images/avatars/10.png').default
          },
          {
            size: 'sm',
            title: 'John Parker',
            img: require('@src/assets/images/avatars/11.png').default
          }
        ]
      },
      {
        id: 5,
        totalUsers: 2,
        title: 'Restricted User',
        users: [
          {
            size: 'sm',
            title: 'Kim Merchent',
            img: require('@src/assets/images/avatars/10.png').default
          },
          {
            size: 'sm',
            title: 'Sam Dsouza',
            img: require('@src/assets/images/avatars/6.png').default
          },
          {
            size: 'sm',
            title: 'Nurvi Karlos',
            img: require('@src/assets/images/avatars/3.png').default
          },
          {
            size: 'sm',
            title: 'Andrew Tye',
            img: require('@src/assets/images/avatars/8.png').default
          },
          {
            size: 'sm',
            title: 'Rossie Kim',
            img: require('@src/assets/images/avatars/9.png').default
          }
        ]
      }
    ]
  }
  // const response = await axios.get('/apps/roles/data')
  // return {
  //   data: []
  // }
})

export const addRol = createAsyncThunk('roles/addRol', async (rol, { dispatch, getState }) => {
  let result = await axios.post('/apps/roles/add-rol', rol)
  await dispatch(getData(getState().roles.params))
  return result
}
)

export const updateRol = createAsyncThunk('roles/updateRol', async (rol, { dispatch, getState }) => {
  let result = await axios.post('/apps/roles/update-rol', { rol })
  await dispatch(getData(getState().roles.params))
  return result
}
)

export const deleteRol = createAsyncThunk('roles/deleteRol', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/roles/delete', { id })
  await dispatch(getData(getState().roles.params))
  return id
})

/* istanbul ignore next  */
mock.onGet('/api/roles/getPermissions').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const rolesArr = [
    {
      id: "dashboard",
      name: "Dashboard",
      actions: [
        {
          nameId: "view",
          name: "Ver"
        }
      ]
    },
    {
      id: "catalogs",
      name: "Catálogos",
      actions: [
        {
          nameId: "view",
          name: "Ver"
        },
        {
          nameId: "create",
          name: "Crear"
        },
        {
          nameId: "edit",
          name: "Editar"
        }
      ]
    },
    {
      id: "products",
      name: "Productos",
      actions: [
        {
          nameId: "view",
          name: "Ver"
        }
      ]
    },
    {
      id: "promoters",
      name: "Promotores",
      actions: [
        {
          nameId: "view",
          name: "Ver"
        },
        {
          nameId: "create",
          name: "Crear"
        },
        {
          nameId: "edit",
          name: "Editar"
        }
      ]
    },
    {
      id: "orders",
      name: "Historial de pedidos",
      actions: [
        {
          nameId: "view",
          name: "Ver"
        }
      ]
    },
    {
      id: "settings",
      name: "Configuraciones",
      actions: [
        {
          nameId: "all",
          name: "Todos los permisos"
        }
      ],
      subPermissions: [
        {
          id: "users",
          name: "Usuarios",
          actions: [
            {
              nameId: "view",
              name: "Ver"
            },
            {
              nameId: "create",
              name: "Crear"
            },
            {
              nameId: "edit",
              name: "Editar"
            }
          ]
        },
        {
          id: "roles",
          name: "Roles",
          actions: [
            {
              nameId: "view",
              name: "Ver"
            },
            {
              nameId: "create",
              name: "Crear"
            },
            {
              nameId: "edit",
              name: "Editar"
            }
          ]
        },
        {
          id: "discountLevel",
          name: "Nivel de descuento",
          actions: [
            {
              nameId: "view",
              name: "Ver"
            },
            {
              nameId: "create",
              name: "Crear"
            },
            {
              nameId: "edit",
              name: "Editar"
            }
          ]
        }
      ]
    }

  ]

  return [
    200,
    {
      permissions: rolesArr
    }
  ]
})

export const getPermissions = createAsyncThunk('roles/getPermissions', async () => {
  const response = await axios.get('/api/roles/getPermissions')
  return response.data.permissions

})

export const rolesSlice = createSlice({
  name: 'roles',
  initialState: {
    data: [],
    permissions: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
        state.allData = action.payload.allData
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.permissions = [...action.payload]
      })
  }
})


export default rolesSlice.reducer